<template>
  <div class="home">
    <div class="home__vip" @click="onRoute('')">
      <img src="../../assets/home-vip.png" @click="onRoute('/homeForPrivate')" />
    </div>
    <div class="home__city" @click="onRoute('/homeForPersonal')">
      <img src="../../assets/home-city.png" />
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import useWechat from '@/utils/useWechat'

export default {
  setup() {
    const router = useRouter()
    useWechat()

    const onRoute = url => {
      if (!url) {
        return
      }
      if (url == "/homeForPrivate") {
        //router.push('https://szfh.ue-link.com/szfh/i6ve4');
        window.location = "https://szfh.ue-link.com/szfh/i6ve4";
      } else {
        router.push(url);
      }
    }
    return {
      onRoute
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100vh;
  background-image: url('../../assets/home-bg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  overflow: hidden;
  background-color: #902d2b;

  .home__vip {
    margin: 34px 0 0 18px;
    width: 340px;
    height: 289px;

    img {
      width: 340px;
      height: 289px;
    }
  }

  .home__vip:active {
    opacity: 0.8;
  }

  .home__city {
    margin: 23px 0 0 18px;
    width: 340px;
    height: 289px;

    img {
      width: 340px;
      height: 289px;
    }
  }

  .home__city:active {
    opacity: 0.8;
  }
}
</style>